export var EmailIds = {
    getEmailtemplate:{
        EmailforintimationtoAssignedUser:{
            emailtemplateId:"5b6457012e31c0b53b797982",
            MailReminderStaticID:'2',
            Priority:'2'
        },
        EmailforintimationtoResponsibleUser:{
            emailtemplateId:"5b645b142e31c0b53b799d33",
            MailReminderStaticID:'3',
            Priority:'1'
        },
        EmailforRemindertoAssignedUser:{
            emailtemplateId:"5b645c7a2e31c0b53b79a865",
            MailReminderStaticID:'4',
            Priority:'3'
        },
        EmailforRemindertoResponsibleUser:{
            emailtemplateId:"5b645d402e31c0b53b79afc8",
            MailReminderStaticID:'5',
            Priority:'4'
        },
        Escalation1OfAssignToUser:{
            emailtemplateId:"5bd2bf094db498517b3b19e3",
            MailReminderStaticID:'11',
            Priority:'5'
        },
        EscalionEmailtoResponsibleUser1:{
            emailtemplateId:"5bd18e594db498517b38b916",
            MailReminderStaticID:'6',
            Priority:'6'
        },
        Escalation2OfAssignToUser:{
            emailtemplateId:"5bd2bf284db498517b3b1ace",
            MailReminderStaticID:'12',
            Priority:'7'
        },
        EscalionEmailtoResponsibleUser2:{
            emailtemplateId:"5bd193d54db498517b38da2e",
            MailReminderStaticID:'10',
            Priority:'8'
        },
        EmailforRemindertoSelectedUser:{
            emailtemplateId:"5bf265ffa59f8243fc55a7f5",
            MailReminderStaticID:'13'
        },
        EmailForAddedRecipient:{
            emailtemplateId:"5cb446b6fd6d66dad53a02a6",
            mailReminderStaticID:'14'
        },
        EmailForAddedUPSI:{
            emailtemplateId:"5cb44a8bfd6d66dad53a0960",
            mailReminderStaticID:'15'
        },
        EmailForEditUPSI:{
            emailtemplateId:"5cb44d0bfd6d66dad53a0f81",
            mailReminderStaticID:'16'
        }
    }
}